import type { ReactElement } from 'react';

import { cn } from '@/components/ui/cn';

import { escalateAfterLabel, repeatLabel } from '../presentation';
import type { NotificationRule } from '../types';

interface Props {
  overdue: NotificationRule;
  escalation: NotificationRule;
  onEdit: () => void;
}

const TARGET_TEXT = {
  department_supervisors: 'Supervisores del departamento (organigrama del LMS)',
  quality: 'Calidad de la empresa',
} as const;

/** Escalera de escalamiento del mockup, con el alcance contratado: un nivel, del
 *  responsable al superior inmediato. Sus parámetros viven en la regla Etapa vencida. */
export function EscalationCard({ overdue, escalation, onEdit }: Props): ReactElement {
  const target = overdue.escalationTarget ?? 'department_supervisors';
  // Mismo criterio que el evaluador (so=330 stageConfigFrom): escala si la regla de
  // escalamiento está activa y hay destino, aunque los recordatorios de vencida estén apagados.
  const active = escalation.enabled && target !== 'none';
  const days = escalateAfterLabel(overdue.escalateAfterDays ?? 2);

  return (
    <div className="card rise d2">
      <div className="ch">
        <h3>Escalamiento automático</h3>
        <span className="count">al vencerse el plazo</span>
      </div>
      <div className="cb">
        <div className={cn('esc', !overdue.enabled && 'off')}>
          <span className="lv">1</span>
          <div className="esc-txt">
            <div className="esc-who">Responsable de la actividad</div>
            <div className="esc-when">
              {overdue.enabled
                ? `Aviso al vencer · recordatorio ${repeatLabel(overdue.repeatEvery ?? 'daily')}`
                : 'Sin recordatorios de vencimiento'}
            </div>
          </div>
        </div>
        <div className={cn('esc sep', !active && 'off')}>
          <span className="lv">2</span>
          <div className="esc-txt">
            <div className="esc-who">Superior inmediato</div>
            <div className="esc-when">
              {active ? `${TARGET_TEXT[target]} · ${days}` : 'Sin escalamiento'}
            </div>
          </div>
        </div>
        <div className="esc-foot">
          {active && target === 'department_supervisors' && (
            <p>Si ningún supervisor usa el sistema, el aviso llega a Calidad.</p>
          )}
          <button type="button" className="btn mut sm" onClick={onEdit}>
            Editar escalamiento
          </button>
        </div>
      </div>
    </div>
  );
}
